import './BetbookOddBetCount.less';
import React from 'react';
import { navigate } from '@/routing';
import { NIKE1_MATCH } from '@/routing/routes';

export function BetbookOddBetCount({ matchBetCount, sportEventId, urlMeta }) {
    function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        navigate(NIKE1_MATCH, { eventId: sportEventId, meta: urlMeta });
    }

    return matchBetCount ? (
        <button className="betbook-odd-bet-count text-bold fs-12 pl-8" onClick={onClick}>
            {(matchBetCount >= 0 ? '+' : '-') + matchBetCount}
        </button>
    ) : null;
}
